import {IPoint} from '../interfaces/primitives/IPoint';

export class StaticData
{
    static translationsMap: Map<string, string>;
    static readonly sceneBorderThickness: number = 6;
    static readonly sceneMaskRadius: number = 20;
    static readonly platform = navigator.platform.toUpperCase();
    static readonly pieMenuColorNormal: number = 0x41454a;
    static readonly pieMenuColorHover: number = 0xfe5616;
    static readonly pieMenuCenterRadius: number = 50;
    static readonly pieMenuRoundCornersRadius: number = 8;
    static isAdmin: boolean;
    static handPadding: number = 10;
    static playerId: string;
    static dragSilentArea: number = 10;
    static handCardStandUpOffset: number = 20;
    static pieMenuRadius: number = 150;
    static handCardsMaskYOffset: number = -100;
    static sceneBorderColor: number = 0xf65a00;
    static handCardBiggerScale: number = 1.2;
    static angleStep: number = 15;
    static notActiveMouseUnselectTimeout: number = 5000;
    static videoSeatSizes: IPoint = {x: 290, y: 217};
    static videoSeatBorderWidth: number = 5;
    static videoSeatBorderRadius: number = 17;
    static videoSeatActivePlayerStrokeBorderRadius: number = 17;
    static videoSeatActivePlayerStrokeMargin: number = 15;
    static videoSeatBottomBarHeight: number = 72;
    static videoSeatBottomBarColor: number = 0x25282D;
    static videoSeatBottomBarMuteButtonsRadius: number = 19;
    static videoSeatBottomBarMicEnabledColor: number = 0xF65A00;
    static videoSeatBottomBarMicDisbaledColor: number = 0x3F4246;
    static videoSeatBottomBarCamEnabledColor: number = 0xF65A00;
    static videoSeatBottomBarCamDisbaledColor: number = 0x3F4246;
    static videoSeatPointsCounterRadius: number = 23;
    static videoSeatLeaveButtonRadius: number = 8;
    static videoSeatLeaveButtonColor: number = 0x25282D;
    static videoSeatLeaveButtonWidth: number = 70;
    static videoSeatLeaveButtonAppearWidth: number = 48;
    static videoSeatLeaveButtonHeight: number = 48;
    static videoSeatScales: number[] = [.5, .65, .8, 1];
    static videoSeatScalesButtonSize: number = 44;
    static videoSeatScalesButtonPointsSizes: number[] = [14, 18, 22, 26];
    static videoSeatScalesButtonPointAlphaSelected: number = 1;
    static videoSeatScalesButtonPointAlphaUnselected: number = .5;
    static drawCursorMinimalSize:number = 5;
    static drawCursorMaximalSize:number = 30;
    static charsAndNumbers: string = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyzАБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдеёжзийклмнопрстуфхцчшщъыьэюя .,{}[]!?/@#$%^&*()_+|<>"№;%:*()`~-=+_\\';
}
